import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Logo from '../Assets/logo.png';
import FooterImage from '../Assets/Image1.png'; // Import the background image
import './Footer.css'; // Import the CSS file

const Footer = () => {
  return (
    <footer
      className="footer-background"
      style={{
        backgroundImage: `url(${FooterImage})`, // Set the background image dynamically
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="footer-overlay">
        <Container>
          <Row>
            <Col md={6} className="text-left">
              <img src={Logo} alt="University Logo" width="300px" height="80" className="mb-3" />
              <h5>University Research Council </h5>
              <p className="mb-1">A 6 Building Uda Peradeniya Road</p>
              <p className="mb-1">University of Peradeniya </p>
              <p className="mb-1">20400, Sri Lanka</p>
              <p className="mb-1">Phone: +94 81 205 9390</p>
              <p className="mb-1">Email: secretaryurc@gs.pdn.ac.lk</p><br></br>
             <span className="">
              Copyright © 2025 URC, University of Peradeniya. All rights reserved.
              &nbsp;|&nbsp;<br></br>
              Developed by Harshani Rathnayake
              </span>

            </Col>
            <Col md={6}>
             
            </Col>
          </Row>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
